export default __webpack_public_path__ + "img/bg_distribution-06c79987052f3332424a1550da35f812.png";